import React from 'react';
import { useTabs } from '../../hooks/useTabs';

export const Menu: React.FC = () => {
  const { tabs } = useTabs();

  return (
    <>
      {tabs.map(({ MenuItem, pathname, instrument }, i) => (
        <MenuItem key={i} to={`/${pathname}`} instrument={instrument} />
      ))}
    </>
  );
};
